import React from "react";

function PrintHeader({ className, academicYear, assessmentName }) {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="alpaca-print-header">
      <div className="printout-logo" />
      <div className="alpaca-print-header-text">
        <span className="alpaca-print-header-class">{className}</span>
        <span className="alpaca-print-header-year">
          School Year: {academicYear}
        </span>
        <span className="alpaca-print-header-year">
          Screener Name: {assessmentName}
        </span>
        <span className="alpaca-print-header-powered">
          Powered by ALPACA © {currentYear}
        </span>
      </div>
    </div>
  );
}

export default PrintHeader;